import Vue from 'vue';
import newsTransformer from './../../transformers/news';

const success = (news, resolve) => {
  news = newsTransformer.fetch(news);
  Vue.router.push({
    name: 'campaigns.edit',
    params: {
      id: news.newsCampaignId,
    },
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(newsTransformer.fetch(errors));
};

export default news => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('news', news)
      .then(() => {
        success(news, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/news/store.js